import React from "react";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";

const WebhookWidget = ({ item, isSelected, onSelectLog }) => {
  const { t: translate } = useTranslation();
  return (
    <div
      key={item.id}
      onClick={() => onSelectLog && onSelectLog(item)}
      className={`p-2 bg-white border rounded mb-2 flex-shrink-0 ${
        isSelected ? "border-primary shadow-sm" : ""
      }`}
    >
      {/* Hàng 1: ID (Trái) - Thời lượng (Phải) */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span
          className="font-weight-bold text-dark text-truncate mr-2"
          style={{ maxWidth: "60%" }}
          title={`${translate("webhook.ID")}: ${item.id}`}
        >
          {translate("webhook.ID")}: {item.id}
        </span>
        <div>
          <Tag color={item.color} className="m-0">
            {item.statusText}
          </Tag>
        </div>
      </div>

      {/* Hàng 2: Trạng thái (Trái) - Thời gian (Phải) */}
      <div className="d-flex justify-content-between align-items-center">
        <span className="text-secondary text-nowrap">
          {translate("webhook.time")}: {item.createdAt}
        </span>
        <span className="text-muted text-nowrap">
          {translate("webhook.duration")}: {item.duration}
        </span>
      </div>
    </div>
  );
};

export default WebhookWidget;